import { Component, OnInit, Inject, HostBinding } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dlg-success-buy',
    templateUrl: './dlg-success-buy.component.pug',
    styleUrls: ['./dlg-success-buy.component.less'],
})
export class DlgSuccessBuyComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DlgSuccessBuyComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
    }

    onClose() {
        this.dialogRef.close(false);
    }

}
